import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CrudDataService } from '../../shared/services/crud-data.service';
import { SecurityService } from '../../shared/services/security.service';
import { Configuration } from '../../app.configuration.service';
import { DocumentoVenda } from 'src/app/model/documentoVenda/documentoVenda';
import { Observable } from 'rxjs';
import { FileInfo } from '../../shared/model/generic/fileInfo';
import { decode } from 'base64-arraybuffer';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class DocumentoVendaDataService extends CrudDataService<DocumentoVenda> {

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    super(http, configuration, securityService);
    this.controllerName = 'v1/DocumentoVenda';
  }

  public httpGetFiles: any = (documentoId: number, fileType: string): Observable<FileInfo[]> => {
    const fullUrl = `${this.configuration.apiServerUrl}/api/${this.controllerName}/${documentoId}/${fileType}`;
    return this.http
      .get(fullUrl, this.options)
      .pipe(
        map(response => {
          const myData = response;
          const myFiles = new Array<FileInfo>();
          (myData as any).forEach((file: any) => {
            if ((file as any).content != null) {
              const myFileInfo = new FileInfo();
              myFileInfo.filename = (file as any).filename;
              myFileInfo.content = new Blob([decode((file as any).content)], { type: (file as any).contentType });
              myFiles.push(myFileInfo);
            }
          });
          return myFiles;
        })
        , catchError(this.handleError));
  }

}
